import FileSaver from "file-saver";
import * as Papa from "papaparse";
import ReactDOM from "react-dom";
import Sortable from "sortablejs";
import { defaultServiceContext } from "@app/contexts";
import DesignerSetting from "@app/DesignerSetting";
import BaseComponent from "@app/form_components/BaseComponent";
import Button from "@app/form_components/Button";
import CompoundItemList from "@app/form_components/CompoundItemList";
import CompoundItemListEditor from "@app/form_components/CompoundItemListEditor";
import OldInput from "@app/form_components/OldInput";
import {
  createUuid,
  updateLastChange,
  updateTree
} from "@app/utilities";
import CompoundIntentsCSV from "@app/widgets/dialogs/CompoundIntentsCSV";
import NewElementDialog from "@app/widgets/dialogs/NewElementDialog";

const { intentService } = defaultServiceContext;

export class CompoundIntentPage extends BaseComponent {
    /**
     * Global intent handling
     * @module CompoundIntentPage
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.filtered = [];
        this.dataCache = {};
        this.state = {
            'compoundIntents': window.apm.serialized.compoundIntents,
            'isFiltered': false,
            //'mappingEditConfig':[ {isEditMappingIntent2:false,top: 0, left: 0, width: 'auto'},{isEditMappingtoIntent:false,top: 0, left: 0, width: 'auto'}],
            'mappingEditConfig': { top: 0, left: 0, width: 'auto', valKey: '' },
            'selectedIntentListItem': {},
            'selectedIdx1': '',
            'selectedIdx2': '',

        };
    }

    /**
     * Set config proxy; set own data model before updating context
     * @param {string} key
     * @param {Object} value
     */
    setConfig(key, value) {

        if (key === "toIntent" || key === "fromIntent2") {
            //find intent
            const global_intent = window.apm.serialized.compoundIntents.find(el => el.id === this.state.selectedIntentListItem.id);

            //update with new value
            if (global_intent) {
                global_intent[key] = value;
                global_intent.lastLocalChange = window.apm.timestamp;
            }


            //notify apm that global state has ghanged
            window.apm.setSerializedChanged();

            //update intent list display
            if (this.state.isFiltered) {
                this.setState({ 'compoundIntents': this.filtered });
            } else {
                this.setState({ 'compoundIntents': window.apm.serialized.compoundIntents });
            }

        }

        if (key === "newIntent") { //adds intent
            const node = window.apm.getNode(value);
            const id = createUuid();
            if (node) {
                if (!window.apm.serialized.compoundIntents) {
                    window.apm.serialized.compoundIntents = [{ id: id, fromIntent1: value, fromIntent2: null, toIntent: null, createdTime: window.apm.timestamp, lastLocalChange: window.apm.timestamp, author: DesignerSetting.s.author }];
                } else {
                    window.apm.serialized.compoundIntents = [{ id: id, fromIntent1: value, fromIntent2: null, toIntent: null, createdTime: window.apm.timestamp, lastLocalChange: window.apm.timestamp, author: DesignerSetting.s.author }, ...window.apm.serialized.compoundIntents];
                }
                window.apm.setSerializedChanged();
                this.setState({ 'compoundIntents': window.apm.serialized.compoundIntents });
                this.setState({ 'isFiltered': false });
                this.getDomSelf().find("#globalIntent_q").val("");
            }
            this.dataCache[key] = "";
        } else {
            this.dataCache[key] = value;
        }
    }


    /**
     * Get current context value
     * @param {string} key
     * @returns {Object}
     */
    getConfig(key) {
        return this.dataCache[key];
    }

    // Sortable list item handler for end-of-drag events
    reload(event) {
        if (event.oldIndex === event.newIndex) {
            return;
        }
        const list = $(event.to);
        const listItems = list.find("li");
        var newList = [];
        for (var i = 0; i < listItems.length; i++) {
            newList.push({
                id: listItems[i].getAttribute("data-id"),
                fromIntent1: listItems[i].getAttribute("data-fromint1"),
                fromIntent2: listItems[i].getAttribute("data-fromint2"),
                toIntent: listItems[i].getAttribute("data-toint"),
                createdTime: Number(listItems[i].getAttribute("created-time")),
                lastSavedChange: Number(listItems[i].getAttribute("lastsavedchange")),
                lastLocalChange: window.apm.timestamp
            });
        }
        window.apm.serialized.compoundIntents = newList;
        window.apm.setSerializedChanged();
        this.setState({ 'compoundIntents': newList });
    }

    update(idx, value) {
        if (!window.apm.serialized.compoundIntents) {
            window.apm.serialized.compoundIntents = [];
            return;
        }
        window.apm.serialized.compoundIntents[idx] = value;
        updateLastChange(window.apm.serialized.compoundIntents[idx]);
        window.apm.setSerializedChanged();
        this.forceUpdate();
    }

    removeIntent(param) {
        if (!window.apm.serialized.compoundIntents) {
            window.apm.serialized.compoundIntents = [];
            return;
        }
        window.apm.updateDeletedCompoundIntentsMap(window.apm.serialized.compoundIntents[param]);
        window.apm.serialized.compoundIntents.splice(param, 1);
        window.apm.setSerializedChanged();

        updateTree();

        this.setState({ 'compoundIntents': window.apm.serialized.compoundIntents });

        // preserve filter
        if (this.state.isFiltered) {
            this.doFilter(this.getDomSelf().find("#globalIntent_q").val());
        }

    }

    /**
     * Get reference to input box itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    bindTagWrapper() {
        const tagList = this.getDomSelf().children(".tag-items");
        if (tagList.length && !this.sortable) {
            this.sortable = Sortable.create(tagList[0], {
                ghostClass: "sortable-ghost",  // Class name for the drop placeholder
                chosenClass: "sortable-chosen",  // Class name for the chosen item
                dragClass: "sortable-drag",  // Class name for the dragging item
                onEnd: (event) => {
                    this.reload(event);
                }
            });
        }
    }
    createIntent() {
        const newIntent = intentService.initializeIntent();
        const treeDom = $('#tl_container');
        NewElementDialog.addElement(treeDom, newIntent);
        window.apm.notification.post("error", window.l.notification.new_intent);
    }
    componentDidMount() {
        this.bindTagWrapper();
    }

    // called when props or state are updated
    componentDidUpdate(prevProps, prevState, snapshot) {
        // prevent sorting on filtered lists
        this.sortable.options.disabled = this.state.isFiltered;
    }

    doFilter(val) {
        //source of truth
        const intents = window.apm.serialized.compoundIntents;

        if (val) { // why test for val?
            if (intents.length === 0) { //why test for intents list?
                return;
            }
            const query = new RegExp(val, "ig");
            this.filtered = [];
            for (var i = 0; i < intents.length; i++) {
                const node = window.apm.getNode(intents[i].intent);
                if (node && node.name.match(query)) {
                    this.filtered.push(intents[i]);
                }
            }
        }
        if (val && val.length > 0) {
            this.setState({ 'compoundIntents': this.filtered });
            this.setState({ 'isFiltered': true });
        } else {
            this.setState({ 'compoundIntents': intents });
            this.setState({ 'isFiltered': false });
        }
    }

    initEditMappingDropdown(xPos, yPos, width, valKey) {
        // this.setState({'mappingEditConfig': [{'isEditMappingIntent2': true, top: x1Pos, left: y1Pos, width: width1},{'isEditMappingtoIntent': true, top: x2Pos, left: y2Pos, width: width2}]});
        this.setState({ 'mappingEditConfig': { 'isEditMapping': true, top: xPos, left: yPos, width: width, valKey: valKey } });
    }

    onEditComplete() {
        this.setState({ 'mappingEditConfig': { 'isEditMapping': false } });
    }

    setSelectedIntentListItem(intent) {
        const selectedIdx1 = window.apm.knowledgeBase.getIndexFromValue(intent.fromIntent2, window.apm.knowledgeBase.getIntents());
        const selectedIdx2 = window.apm.knowledgeBase.getIndexFromValue(intent.toIntent, window.apm.knowledgeBase.getIntents());
        this.setState({ 'selectedIntentListItem': intent });
        this.setState({ 'selectedIdx1': selectedIdx1 });
        this.setState({ 'selectedIdx2': selectedIdx2 });
    }
    /**
     * export compound intents in in csv format
     */
    exportCompoundIntents() {
        const compoundIntents = window.apm.serialized.compoundIntents;
        let compoundIntentFields = ['FromIntent1', 'FromIntent2', 'ToIntent'];
        let compoundIntentsRowData = [compoundIntentFields];
        compoundIntents.map(compoundIntent => {
            let row = [];
            let intent1 = window.apm.getNode(compoundIntent.fromIntent1);
            if (intent1) {
                row.push(intent1.name);

            }
            let intent2 = window.apm.getNode(compoundIntent.fromIntent2);
            if (intent2) {
                row.push(intent2.name);
            }
            let toIntent = window.apm.getNode(compoundIntent.toIntent);
            if (toIntent) {
                row.push(toIntent.name);
            }
            compoundIntentsRowData.push(row);
        });
        const newcompoundIntentsCsv = Papa.unparse(compoundIntentsRowData);
        var blob = new Blob([newcompoundIntentsCsv], { type: "csv;charset=utf-8" });

        FileSaver.saveAs(blob, "compoundIntents.csv");
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div className={"intents-table"}>

                <div className={"tag-new"}>

                    <div className={"row"}>
                        <div className={"col-md-6"}>
                            {
                                <OldInput hint={window.l.settings.type_to_add_intent}
                                    context={this} valKey={"newIntent"}
                                    suggestion={"intent"} inUse={this.state.compoundIntents}
                                    excludeInUse={true} />}
                        </div>
                        <div className={"col-md-3  col-md-offset-3"}>
                            <div>
                                <i className="fe icon-search input-prefix-icon" />
                                <i className="fe icon-x input-suffix-icon clear-button"
                                    onClick={() => {
                                        this.getDomSelf().find("#globalIntent_q").val("");
                                        this.getDomSelf().find(".clear-button").hide();
                                        this.doFilter("");
                                    }} />
                                <input type="search" id="globalIntent_q" className="form-component v-marginal search" placeholder={window.l.settings.search_intent}
                                    onChange={() => {
                                        const val = this.getDomSelf().find("#globalIntent_q").val();
                                        if (val && val.length) {
                                            this.getDomSelf().find(".clear-button").show();
                                        } else {
                                            this.getDomSelf().find(".clear-button").hide();
                                        }
                                        this.doFilter(val);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={"col-md-6"} style={{ display: "flex" }}>
                            <div style={{ display: "flex", paddingRight: '1em' }}> <Button label={"Import"} desc={this.state.label}
                                callback={() => {
                                    window.apm.popup(
                                        window.l.settings.csv_data,
                                        '<div class="custom_script_container"></div>',
                                        '<button class="w2ui-btn secondary" onclick="w2popup.close();">' +
                                        window.l.popup.close +
                                        "</button> " +
                                        '<button class="w2ui-btn primary add-button">' +
                                        window.l.popup.upload_csv +
                                        "</button> ",
                                        [
                                            ".custom_script_container",

                                            () => {
                                                ReactDOM.render(
                                                    <CompoundIntentsCSV />,
                                                    $(".custom_script_container").get(0)
                                                );
                                                $(".w2ui-popup")
                                                .find(".add-button")
                                                .on("click", function () {
                                                    document.dispatchEvent(
                                                        new CustomEvent("ev-dialog-add")
                                                        );
                                                    });
                                                    
                                                }
                                        ]
                                    );
                                }}
                                context={this}
                            />
                            </div>
                            <Button label={"Export"} className="w2ui-btn primary" callback={() => { this.exportCompoundIntents() }} />
                        </div>
                        <div className={"col-md-3 col-md-offset-3"}>
                            <div>
                                <Button label={window.l.intents.create_intent} wide={false} value={this.value} tint={"warning"}
                                    callback={() => {
                                        this.createIntent()
                                    }}

                                />
                            </div>
                        </div>
                        <div className={"col-md-7"}>

                        </div>
                    </div>

                </div>
                <div>
                    <span style={{ display: 'inline-block', width: '33%', fontWeight: 'bold' }}>From Intent 1</span>
                    <span style={{ display: 'inline-block', width: '33%', fontWeight: 'bold' }}>From Intent 2</span>
                    <span style={{ display: 'inline-block', width: '33%', fontWeight: 'bold' }}>To Intent</span>

                </div>
                <ul className={"tag-items"}>
                    {
                        this.state.compoundIntents.map((intent, i) => {
                            return <CompoundItemList
                                highlight={this.state.isFiltered} data={intent}
                                context={this}
                                tagIdx={i}
                                key={i + intent.fromIntent1 + "::" + intent.fromIntent2}
                                isFiltered={this.state.isFiltered} />
                        })
                    }
                    {!this.state.compoundIntents || (this.state.compoundIntents && this.state.compoundIntents.length === 0) &&
                        <strong>There are no Compound Intents to display</strong>
                    }
                </ul>

                {this.state.mappingEditConfig.isEditMapping &&
                    <CompoundItemListEditor
                        top={this.state.mappingEditConfig.top}
                        left={this.state.mappingEditConfig.left}
                        width={this.state.mappingEditConfig.width}
                        contextClassName={"editMapping"}
                        options={window.apm.knowledgeBase.getIntents()}
                        context={this}
                        optionType={this.state.mappingEditConfig.valKey}
                        valKey={"editMapping"}
                        selection1={this.state.selectedIdx1}
                        selection2={this.state.selectedIdx2} />
                }
            </div>
        );
    }
}
